import {
  StatusWithNoneAndCancellation,
  EventStatus,
  statusListWithNoneOption,
  statusListWithCancellationOption,
  statusWithNoneAndCancellation,
  statusList
} from '@domain/shifthandover'
import {CommonDropDown, CommonProps} from '@hconnect/common/components/shiftEventFormFields'
import {EventStatusLabel} from '@widgets/common-shift-event'
import React from 'react'

const getStatusOptions = (
  allow?: Extract<StatusWithNoneAndCancellation, 'none' | 'cancelled'>[]
): ReadonlyArray<StatusWithNoneAndCancellation> => {
  if (allow?.includes('cancelled') && allow.includes('none')) {
    return statusWithNoneAndCancellation
  }
  if (allow?.includes('none')) {
    return statusListWithNoneOption
  }
  if (allow?.includes('cancelled')) {
    return statusListWithCancellationOption
  }
  return statusList
}

export const EventStatusDropDown = <S extends EventStatus<StatusWithNoneAndCancellation>>(
  props: CommonProps<S> & {
    allow?: Extract<StatusWithNoneAndCancellation, 'none' | 'cancelled'>[]
  }
): React.ReactElement => {
  const {allow, ...rest} = props
  const commonProps: CommonProps<S> = rest as CommonProps<S>

  const options = getStatusOptions(allow) as ReadonlyArray<S>

  return (
    <CommonDropDown<S>
      {...commonProps}
      keyName="status"
      options={options}
      customTemplate={(status) => {
        return <EventStatusLabel status={status} />
      }}
    />
  )
}
